/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMunicipalCommand } from '../../models/delete-municipal-command';
import { DeleteMunicipalCommandResult } from '../../models/delete-municipal-command-result';

export interface ApiMunicipalDeleteMunicipalDelete$Params {
      body?: DeleteMunicipalCommand
}

export function apiMunicipalDeleteMunicipalDelete(http: HttpClient, rootUrl: string, params?: ApiMunicipalDeleteMunicipalDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMunicipalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMunicipalDeleteMunicipalDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteMunicipalCommandResult>;
    })
  );
}

apiMunicipalDeleteMunicipalDelete.PATH = '/api/Municipal/DeleteMunicipal';
